import React from 'react';
import {MENU_IDS} from '../../../constants/menuIds';
import {ContextMenuTrigger} from '../../../incase-domain/components/contextMenu/ContextMenu';

export function SlideContextMenuTrigger({children}: React.PropsWithChildren): JSX.Element {
    return <ContextMenuTrigger menuId={MENU_IDS.SLIDE}>{children}</ContextMenuTrigger>;
}

export default SlideContextMenuTrigger;
